module.exports = __webpack_public_path__ + "img/29_23.2b18fb77.png";